import type { ToneCharacteristics, ToneScene } from '../../models/toneAnalysis'
import { formatEnum, formatPercent } from '../../utils/toneAnalysisFormat'

type ToneSceneCardProps = {
  scene: ToneScene
}

const characteristicLabels: Array<[keyof ToneCharacteristics, string]> = [
  ['brightness', 'Bright'],
  ['warmth', 'Warm'],
  ['presence', 'Presence'],
  ['saturation', 'Sat'],
  ['width', 'Width'],
  ['ambience', 'Amb'],
]

export function ToneSceneCard({ scene }: ToneSceneCardProps) {
  return <article className="ts-analysis-card ts-analysis-scene-card">
    <div className="ts-analysis-card-head">
      <div>
        <span>{formatEnum(scene.musicalRole)} - {formatEnum(scene.gainCategory)}</span>
        <h4>{scene.suggestedName}</h4>
      </div>
      <b>{formatPercent(scene.confidence)}</b>
    </div>
    <div className="ts-analysis-effects">
      {scene.profile.effects.length > 0
        ? scene.profile.effects.map((effect) => <span key={`${scene.id}-${effect.category}-${effect.placement}`}>
            {formatEnum(effect.category)}
          </span>)
        : <span>No detected effects</span>}
    </div>
    <div className="ts-analysis-characteristics">
      {characteristicLabels.map(([key, label]) => <div key={key}>
        <span>{label}</span>
        <b>{formatPercent(scene.profile.characteristics[key])}</b>
      </div>)}
    </div>
  </article>
}
